import React from 'react';
import { Box, Avatar, Typography, IconButton, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const RequestUserCard = ({
  row,
  onAccept,
  onReject,
  isAccepted,
  isRejected,
  onEdit,
  onDelete,
  isUser = false,
}) => {
  const roleText = row.other_position || row.position || 'N/A';

  const accepted = isAccepted?.(row);
  const rejected = isRejected?.(row);

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
        p: '12px',
        mb: '12px',
        boxShadow: '0px 2px 4px 0px #0000000D',
      }}
    >
      {/* Top Section */}
      <Box display="flex" justifyContent="space-between">
        {/* Left Side */}
        <Box display="flex" gap={1} minWidth={0}>
          <Avatar
            src={row.profile_pic || '/default-avatar.png'}
            sx={{ width: 40, height: 40 }}
          />

          <Box textAlign="left" minWidth={0}>
            <Typography fontSize="16px">{row.name}</Typography>

            {/* Email with Ellipsis + Tooltip */}
            <Tooltip title={row.email || ''} arrow>
              <Typography
                color="text.secondary"
                fontSize="14px"
                sx={{
                  maxWidth: 165,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  cursor: 'pointer',
                }}
              >
                {row.email}
              </Typography>
            </Tooltip>
          </Box>
        </Box>

        {/* Right Side - Position */}
        <Box textAlign="right">
          <Typography color="text.secondary" fontSize="14px">
            Position
          </Typography>

          <Typography fontSize="16px">{roleText}</Typography>
        </Box>
      </Box>

      {/* Bottom Section */}
      <Box
        mt={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        {/* Group Badge */}
        <Box
          sx={{
            backgroundColor: '#F2F2F2',
            px: '8px',
            py: '4px',
            borderRadius: '6px',
          }}
        >
          <Typography fontSize="12px">
            Group: {row.TL_name || row.group}
          </Typography>
        </Box>

        {/* Action Area */}
        {isUser ? (
          <Box display="flex" gap={1}>
            <IconButton
              size="small"
              onClick={() => onEdit?.(row)}
              sx={{
                color: '#555',
                borderRadius: '8px',
                backgroundColor: '#FAFAFA',
                '&:hover': {
                  backgroundColor: '#F0F0F0',
                },
              }}
            >
              <EditOutlinedIcon fontSize="small" />
            </IconButton>

            <IconButton
              size="small"
              onClick={() => onDelete(row.id, row.name)}
              sx={{
                color: '#D32F2F',
                borderRadius: '8px',
                backgroundColor: '#FAFAFA',
                '&:hover': {
                  backgroundColor: '#FFEAEA',
                },
              }}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <>
            {!accepted && !rejected && (
              <Box display="flex" gap={3}>
                <Typography
                  onClick={() => onAccept(row)}
                  sx={{
                    cursor: 'pointer',
                    color: '#128D16',
                  }}
                >
                  Accept
                </Typography>

                <Typography
                  onClick={() => onReject(row)}
                  sx={{
                    cursor: 'pointer',
                    color: '#D32F2F',
                  }}
                >
                  Decline
                </Typography>
              </Box>
            )}

            {accepted && (
              <Box
                sx={{
                  border: '1.5px solid #128D16',
                  color: '#128D16',
                  bgcolor: '#E0FFE0',
                  px: '12px',
                  py: '8px',
                  borderRadius: 5,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Accepted <CheckIcon fontSize="small" sx={{ ml: 0.5 }} />
              </Box>
            )}

            {rejected && (
              <Box
                sx={{
                  border: '1.5px solid #D32F2F',
                  color: '#D32F2F',
                  bgcolor: '#FFF0F0',
                  px: '12px',
                  py: '8px',
                  borderRadius: 5,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Declined <CloseIcon fontSize="small" sx={{ ml: 0.5 }} />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default RequestUserCard;
